const ACTIVE_CLASS_MENU = 'Header__menu--active';
const ACTIVE_CLASS_HAMBURGER = 'Hamburger--open';

const hamburgerBtn = document.getElementById('toggle');
const navigation = document.querySelector('.Header__menu');

const closeAllNavigations = () => {
    document.querySelectorAll('.Navigation ul.open').forEach((nav) => nav.classList.remove('open'));
};

const query = window.matchMedia('(max-width: 1024px)');

const handleSetOverflow = () => {
    if (query.matches) {
        if (!navigation.classList.contains(ACTIVE_CLASS_MENU)) {
            document.documentElement.style.overflowY = 'auto';
            closeAllNavigations();
        } else {
            document.documentElement.style.overflowY = 'hidden';
        }
    } else {
        document.documentElement.style.overflowY = 'auto';
    }
};

const toggleMenu = (ev) => {
    ev.currentTarget.classList.toggle(ACTIVE_CLASS_HAMBURGER);
    navigation?.classList.toggle(ACTIVE_CLASS_MENU);

    handleSetOverflow();
};

hamburgerBtn?.addEventListener('click', toggleMenu);

query.addEventListener('change', handleSetOverflow);


const wooTabs = document.querySelectorAll('.WoocommerceTabs__single-tab a');
const isDesktop = screen.width >= 768; // Only enable click event for desktop devices


if (wooTabs && isDesktop) {
    wooTabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault(); // Prevents the default behavior of the link
          const target = document.querySelector(tab.getAttribute('href')); // Select the target element
          const targetTop = target.getBoundingClientRect().top; // Get the top position of the target element
          const offset = targetTop + window.scrollY - 300; // Calculate the offset for scrolling
          window.scrollTo({top: offset, behavior: 'smooth'}); // Scroll to the target element with offset
        });
      });
}

const topbar__info = document.querySelector('.topbar__info ');
if (topbar__info){
    hamburgerBtn?.addEventListener('click', () => {
        if (topbar__info.style.display === 'none') {
            topbar__info.style.display = 'block';
          } else {
            topbar__info.style.display = 'none';
          }
    });
}

